import { Markdown, Text } from "@wojo/ui";
import React from "react";
import { SectionDepartureDates } from "./SectionDepartureDates";
import { useTripBuilder } from "../context/TripBuilderContext";
import { useShowMarketingMessageView } from "../context/use-show-marketing-message-view";

export const TripBuilderMessageViewMarketing = () => {
    const { gcDeparture } = useTripBuilder();
    const showMarketingMessageView = useShowMarketingMessageView();
    if (!showMarketingMessageView) {
        return null;
    }
    const heading =
        gcDeparture?.micrositeContent?.tripBuilderMarketingTitle ?? "";

    const description =
        gcDeparture?.micrositeContent?.tripBuilderMarketingBody ?? "";

    return (
        <>
            <SectionDepartureDates />
            <div style={{ padding: "var(--g-spacing-lg)" }}>
                {!!heading && (
                    <Text.Heading
                        order="5"
                        tag="h2"
                        style={{ marginBottom: "var(--g-spacing-md)" }}
                    >
                        {heading}
                    </Text.Heading>
                )}
                {!!description && <Markdown markdown={description} />}
            </div>
        </>
    );
};
